import pdfIcon from '../icons/pdf.svg'
import docIcon from '../icons/word.svg'
import excelIcon from '../icons/excel.svg'
import generalFileIcon from '../icons/file.svg'


export const getFileTypeIcon = (file_object) => {
  const file_category = file_object.file_type.split('/')

  if (file_category[0] === 'image') {
    return file_object.file_path
  } else if (file_object.file_type === 'application/pdf') {
    return pdfIcon
  } else if (file_object.file_type === 'application/xlsx' || file_object.file_type === 'application/xls' || file_object.file_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return excelIcon
  } else if (file_object.file_type === 'application/docx' || file_object.file_type === 'application/doc' || file_object.file_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.documentapplication/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return docIcon
  } else {
    return generalFileIcon
  }
}